import React from 'react';
import './NoGuestValueProps.less';

const NoGuestValueProps = () => (
  <div className="noguest-value-props">
    <div className="container">
      <div className="row">
        <h3>
          Get the <span className="stroke-01">Most</span> Out of Your Guest List
        </h3>
      </div>
      <div className="row">
        <div className="value-item col-md-3 col-md-offset-1">
          <i className="zolaicon zolaicon-gl-collect" />
          <span>
            Send a link to our handy form to <strong>collect missing addresses</strong>.
          </span>
        </div>
        <div className="value-item col-md-3">
          <i className="zolaicon zolaicon-gl-guest" />
          <span>
            Get <strong>free guest addressing</strong> when you send save the dates and invites.
          </span>
        </div>
        <div className="value-item col-md-3">
          <i className="zolaicon zolaicon-gl-website" />
          <span>
            Create a free website at Zola and let guests <strong>RSVP online</strong>.
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default NoGuestValueProps;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/noGuestValueProps/NoGuestValueProps.jsx